import { render, staticRenderFns } from "./EventConfirmation.vue?vue&type=template&id=6e52c5c4&scoped=true&"
import script from "./EventConfirmation.vue?vue&type=script&lang=js&"
export * from "./EventConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./EventConfirmation.vue?vue&type=style&index=0&id=6e52c5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e52c5c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/usr/src/regapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VCheckbox,VDivider,VFlex,VForm,VLayout,VSpacer})
